import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.4517 30.8181V0.818115H18.5426V30.8181H13.4517ZM0.997162 18.3636V13.2727H30.9972V18.3636H0.997162Z",
    fill: "white"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { ref, Ref } from "vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonAddFiles',
  setup(__props) {

const input = ref(null);

const handleClick = () => {
  if (input.value) {
    (input.value as HTMLInputElement).click();
  }
};

const handleSelect = (e: Event) => {
  if (e.target) {
    const t = e.target as HTMLInputElement;
    if (t.files) {
      store.commit("addFiles", [...t.files]);
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "button-add-files",
      onClick: _withModifiers(handleClick, ["prevent"])
    }, _hoisted_3, 8, _hoisted_1),
    _createElementVNode("input", {
      onChange: handleSelect,
      type: "file",
      ref_key: "input",
      ref: input,
      multiple: "",
      hidden: ""
    }, null, 544)
  ], 64))
}
}

})